module.exports = __webpack_public_path__ + "img/baihe.35edd64c.png";